// extracted by mini-css-extract-plugin
export default {"imageContent":"Vo-z","modal":"Wo-z"};